import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-227ee2c3"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

import { searchFormConfig } from './config/search.config'
import { downloadData, getListData } from '@/service/main/system'
import { usePageSearch } from '@/hooks/userPageSearch'
import { getBeforeDate } from '@/utils/utils'
import { contentTableConfig } from './config/content.config'
import { usePageModal } from '@/hooks/usePageModal'
import { modalConfig } from './config/modal.config'
import { reactive, ref } from 'vue'
import { useStore } from '@/store'
import { usePageModalTable } from '@/hooks/usePageModalTable'
import PageModalTable from '@/components/PageModalTable.vue'
import { modalTableConfig } from './config/modalTable.config'
import { Excel } from '@/utils/ExcelJs'
import { ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'stockStatistics',
  setup(__props) {

const queryBelongList = async () => {
  let belongList = await getListData('/main/ybwave/queryBelongList', {})

  const belong = searchFormConfig.formItems.find(
    (item) => item.field === 'belong'
  )
  belong!.options = belongList.map((item: any) => {
    return { title: item, value: item }
  })

  const belong2 = modalConfig.formItems.find((item) => item.field === 'belong')
  belong2!.options = belongList.map((item: any) => {
    return { title: item, value: item }
  })
}
queryBelongList()

const queryStockList = async () => {
  let stockList = await getListData('/main/ybwave/queryStockList?all=false', {})

  const code = searchFormConfig.formItems.find((item) => item.field === 'code')
  code!.options = stockList.map((item: any) => {
    return {
      title: item.stockCode + ' ' + item.stockName,
      value: item.stockCode
    }
  })

  const code2 = modalConfig.formItems.find((item) => item.field === 'code')
  code2!.options = stockList.map((item: any) => {
    return {
      title: item.stockCode + ' ' + item.stockName,
      value: item.stockCode + '.' + item.stockExchange
    }
  })
}
queryStockList()

var queryParam = {
  date: [getBeforeDate('1_month'), new Date().toISOString().slice(0, 10)]
}

const store = useStore()
store.commit('system/changeQueyryInfo', queryParam)

const resetCb = () => {
  return queryParam
}

const modalTitle = ref('新增')

const newCb = () => {
  modalTitle.value = '新增股票'
  modalConfig.formItems.forEach((item) => {
    if (item.field === 'code') {
      item.isDisabled = false
    } else if (item.field === 'belong') {
      item.isHidden = false
    } else {
      item.isHidden = false
    }
  })
}

const editCb = (item: any) => {
  modalTitle.value = '编辑股票'
  modalConfig.formItems.forEach((item) => {
    if (item.field === 'code') {
      item.isDisabled = true
    } else if (item.field === 'belong') {
      item.isHidden = false
    } else {
      item.isHidden = true
    }
  })
  defaultInfo.value.code = item.code.split('.')[0]
  defaultInfo.value.belong = item.belong.split(',')
}

const callBack = (item: any) => {
  modalTableConfig.title =
    '波段详情' +
    '-' +
    item.code +
    '(' +
    item.name +
    ')' +
    '-' +
    item.date +
    '-' +
    item.belong +
    '-' +
    item.belongTo
}

const getDateRange = (row: any) => {
  let dateBegin = '' + row.dateBegin
  dateBegin =
    dateBegin.slice(0, 4) +
    '-' +
    dateBegin.slice(4, 6) +
    '-' +
    dateBegin.slice(6, 8)
  let dateEnd = '' + row.dateEnd
  dateEnd =
    dateEnd.slice(0, 4) + '-' + dateEnd.slice(4, 6) + '-' + dateEnd.slice(6, 8)
  if (row.dateBegin && row.dateEnd) {
    return dateBegin + ' ~ ' + dateEnd
  } else {
    return ''
  }
}

const getExportData = async () => {
  let queryInfo = store.state.system.queryInfo
  return await getListData('/main/ybwave/queryExportData', queryInfo)
}

const getExportDataAll = async () => {
  let queryInfo = store.state.system.queryInfo
  return await getListData('/main/ybwave/queryAllData', queryInfo)
}

const handleYbwaveSum = () => {
  getExportDataAll().then((res) => {
    let customHeader = [
      '老师',
      '推票数',
      '上涨',
      '下跌',
      '持平',
      '一字板买不了',
      '平均收益率',
      '总涨跌幅',
      '平均荐股次日至今最大收益',
      '成功率',
      '成功股票'
    ]
    let teacherMap: any = {
      程: '程超',
      程超: '程超',
      孙: '孙腾',
      孙腾: '孙腾',
      吴: '吴顶贤',
      吴顶贤: '吴顶贤',
      张: '张进益',
      张进益: '张进益',
      闫: '闫峰',
      闫峰: '闫峰',
      周: '周培',
      周培: '周培',
      系统: '系统选票',
      系统选票: '系统选票'
    }
    let teachers = ['程超', '孙腾', '吴顶贤', '张进益', '闫峰', '周培']
    let header = [
      'teacher',
      'count',
      'up',
      'down',
      'flatNum',
      'limit',
      'avg',
      'zf',
      'avgHighest',
      'okRate',
      'okList'
    ]

    let summaryData: any = {}
    let distinctStock: any = {}
    for (let i = 0; i < teachers.length; i++) {
      let teacher = teachers[i]
      summaryData[teacher] = {
        teacher: teacher,
        count: 0,
        up: 0,
        down: 0,
        flatNum: 0,
        limit: 0,
        avg: 0,
        zf: 0,
        avgHighest: 0,
        zfHighest: 0,
        highestNum: 0, // 荐股至今的股票数，当天推荐，当天不计算最大收益，因此计算均值，分母需要排除
        okCount: 0,
        okRate: 0,
        okList: []
      }
    }
    for (let i = 0; i < res.length; i++) {
      let row = res[i]
      let belongTo = row.belongTo
      if (!belongTo) {
        continue
      }
      let teachers = belongTo.split(',')
      for (let j = 0; j < teachers.length; j++) {
        let teacher = teachers[j]
        teacher = teacherMap[teacher]
        if (!teacher) {
          continue
        }
        let item = summaryData[teacher]
        if (!item) {
          continue
        }
        let stockDistinctKey = row.stockCode + '_' + row.date + '_' + teacher
        let stock = distinctStock[stockDistinctKey]
        if (stock) {
          continue
        }
        distinctStock[stockDistinctKey] = true
        item.count += 1
        let limit = row.high == row.low
        let change = 0
        let highestChange = 0
        if (!limit && row.first) {
          let price = row.price || row.preClose
          change = (price - row.first) / row.first
          if (change > 0) {
            item.up += 1
          } else if (change < 0) {
            item.down += 1
          } else {
            item.flatNum += 1
          }
          let highest = row.highest || 0
          if (highest) {
            highestChange = (highest - row.first) / row.first
            item.highestNum += 1
          }
        }
        if (limit) {
          item.limit += 1
        }
        if (!limit) {
          item.zf += change
          item.zfHighest += highestChange
        }
        let avg = 0
        let avgHighest = 0
        if (item.highestNum > 0) {
          avg = item.zf / (item.count - item.limit)
          avgHighest = item.zfHighest / item.highestNum
        }
        item.avg = avg
        item.avgHighest = avgHighest
        item.okCount += row.recommendOk > 0 ? 1 : 0
        if (row.recommendOk > 0) {
          item.okList.push(row.stockName)
        }
        let okRate = 0
        if (item.count > item.limit) {
          okRate = item.okCount / (item.count - item.limit)
        }
        item.okRate = okRate
      }
    }
    let rows = []
    let style = []
    for (let i = 0; i < teachers.length; i++) {
      let key = teachers[i]
      let row = summaryData[key]
      let newRow = [
        row.teacher,
        row.count,
        row.up,
        row.down,
        row.flatNum,
        row.limit,
        (row.avg * 100).toFixed(2) + '%',
        (row.zf * 100).toFixed(2) + '%',
        (row.avgHighest * 100).toFixed(2) + '%',
        (row.okRate * 100).toFixed(2) + '%',
        row.okList.join(',')
      ]

      if (row.zf > 0) {
        style.push(makeStyle(7, rows.length, 'E73323'))
        style.push(makeStyle(8, rows.length, 'E73323'))
      } else if (row.zf < 0) {
        style.push(makeStyle(7, rows.length, '3B7D22'))
        style.push(makeStyle(8, rows.length, '3B7D22'))
      }
      if (row.avgHighest > 0) {
        style.push(makeStyle(9, rows.length, 'E73323'))
      } else if (row.avgHighest < 0) {
        style.push(makeStyle(9, rows.length, '3B7D22'))
      }
      rows.push(newRow)
    }
    console.log(style)
    // 文件名
    let filename = ts2str(new Date().getTime()).replaceAll(/:| |-/gi, '')
    const excel = new Excel()
    excel.exportExcel({
      name: '股票跟踪统计汇总-' + filename,
      title: '股票跟踪统计汇总-' + filename,
      data: reactive(rows),
      header,
      customHeader,
      colorConfigs: style
    })
  })
}

const makeStyle = (columnIndex: number, rowIndex: number, color: any) => {
  return { columnIndex: columnIndex, rowIndex: rowIndex + 2, color: color }
}

const ts2str = (ts: any) => {
  let date = new Date(parseInt(ts))
  let Year = date.getFullYear()
  let Moth =
    date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  let Day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  let Hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  let Minute =
    date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  let Second =
    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  let GMT =
    Year + '-' + Moth + '-' + Day + ' ' + Hour + ':' + Minute + ':' + Second
  return GMT
}

const handleYbwaveDetail = () => {
  getExportData().then((res) => {
    let customHeader = [
      '股票代码',
      '股票名称',
      '一字板',
      '荐股日期',
      '归属模块',
      '持股至今收益',
      '荐股次日至今最大收益',
      '荐股至最大黄带结束时收益',
      '最大黄带区间收益',
      '最大黄带区间',
      '推荐老师'
    ]
    let header = [
      'code',
      'name',
      'isLimit',
      'date',
      'belong',
      'profit',
      'zfHigh',
      'zf0',
      'zf',
      'range',
      'belongTo'
    ]
    const style: any = []
    res.forEach((item: any, index: number) => {
      if (parseFloat(item.profit) / 100 > 0) {
        style.push(makeStyle(6, index, 'E73323'))
      } else if (parseFloat(item.profit) / 100 < 0) {
        style.push(makeStyle(6, index, '3B7D22'))
      }
      if (parseFloat(item.zfHigh) / 100 > 0) {
        style.push(makeStyle(7, index, 'E73323'))
      } else if (parseFloat(item.zfHigh) / 100 < 0) {
        style.push(makeStyle(7, index, '3B7D22'))
      }
      if (parseFloat(item.zf0) / 100 > 0) {
        style.push(makeStyle(8, index, 'E73323'))
      } else if (parseFloat(item.zf0) / 100 < 0) {
        style.push(makeStyle(8, index, '3B7D22'))
      }
      if (parseFloat(item.zf) / 100 > 0) {
        style.push(makeStyle(9, index, 'E73323'))
      } else if (parseFloat(item.zf) / 100 < 0) {
        style.push(makeStyle(9, index, '3B7D22'))
      }
    })
    // 文件名
    let filename = ts2str(new Date().getTime()).replaceAll(/:| |-/gi, '')
    const excel = new Excel()
    excel.exportExcel({
      name: '股票跟踪明细-' + filename,
      title: '股票跟踪明细-' + filename,
      data: reactive(res),
      header,
      customHeader,
      colorConfigs: style
    })
  })
}

const handleDownloadImport = () => {
  const fileName = '荐股数据上传模板.xlsx'
  downloadData(
    '/main/ybwave/downloadImport',
    {
      fileName: fileName
    },
    'blob'
  ).then((res) => {
    const blob = new Blob([res], {
      type: 'application/octet-stream'
    })
    const down = document.createElement('a')
    down.download = fileName
    down.style.display = 'none'
    down.href = URL.createObjectURL(blob)
    document.body.appendChild(down)
    down.click()
    URL.revokeObjectURL(down.href)
    document.body.removeChild(down)
  })
}

const handleImportSuccess = (res: any) => {
  console.log(res)
  if (res.length > 0) {
    const errs = res.map((item: any) => item.reason).join(',')
    ElMessage({
      type: 'error',
      message: '导入存在异常数据如下：' + errs
    })
  } else {
    ElMessage({
      type: 'success',
      message: '导入成功'
    })
  }
}

const handleImportError = (res: any) => {
  console.log(res)
}

const handleSortDataChange = (value: any) => {
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const [pageContentRef, handleResetClick, handleSearchClick] =
  usePageSearch(resetCb)
const [pageModalRef, defaultInfo, handleNewData, handleEditData] = usePageModal(
  newCb,
  editCb
)
const [
  pageModalTableRef,
  defaultTableInfo,
  dataList,
  handleViewClick,
  dataCount,
  handleSortChange
] = usePageModalTable(callBack)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_PageModal = _resolveComponent("PageModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "ybwave",
      deleteTip: "确认删除吗？",
      onNewBtnClick: _unref(handleNewData),
      onEditBtnClick: _unref(handleEditData),
      onViewClick: _unref(handleViewClick),
      onYbwaveSum: handleYbwaveSum,
      onYbwaveDetail: handleYbwaveDetail,
      onYbwaveDownloadImport: handleDownloadImport,
      onImportSuccess: handleImportSuccess,
      onImportError: handleImportError,
      onSortChange: handleSortDataChange
    }, {
      name: _withCtx((scope) => [
        _createElementVNode("div", {
          style: _normalizeStyle({
          color: scope.row.isLimit == '是' ? '#EF9C38' : ''
        })
        }, _toDisplayString(scope.row.name), 5)
      ]),
      profit: _withCtx((scope) => [
        _createElementVNode("div", {
          style: _normalizeStyle({
          color: parseFloat(scope.row.profit) / 100 > 0 ? '#E73323' : '#3B7D22'
        })
        }, _toDisplayString(scope.row.profit), 5)
      ]),
      zfHigh: _withCtx((scope) => [
        _createElementVNode("div", {
          style: _normalizeStyle({
          color: parseFloat(scope.row.zfHigh) / 100 > 0 ? '#E73323' : '#3B7D22'
        })
        }, _toDisplayString(scope.row.zfHigh), 5)
      ]),
      zf0: _withCtx((scope) => [
        _createElementVNode("div", {
          style: _normalizeStyle({
          color: parseFloat(scope.row.zf0) / 100 > 0 ? '#E73323' : '#3B7D22'
        })
        }, _toDisplayString(scope.row.zf0), 5)
      ]),
      zf: _withCtx((scope) => [
        _createElementVNode("div", {
          style: _normalizeStyle({
          color: parseFloat(scope.row.zf) / 100 > 0 ? '#E73323' : '#3B7D22'
        })
        }, _toDisplayString(scope.row.zf), 5)
      ]),
      signalTitle: _withCtx((scope) => [
        _createElementVNode("div", {
          innerHTML: scope.row.signalTitle
        }, null, 8, _hoisted_1)
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onNewBtnClick", "onEditBtnClick", "onViewClick"]),
    _createVNode(_component_PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: _unref(defaultInfo),
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      pageName: "ybwave"
    }, null, 8, ["defaultInfo", "modalConfig", "title"]),
    _createVNode(PageModalTable, {
      title: "",
      ref_key: "pageModalTableRef",
      ref: pageModalTableRef,
      defaultInfo: _unref(defaultTableInfo),
      contentTableConfig: _unref(modalTableConfig),
      dataList: _unref(dataList),
      dataCount: _unref(dataCount),
      "onSortChange?": _unref(handleSortChange)
    }, {
      dateRange: _withCtx((scope) => [
        _createTextVNode(_toDisplayString(getDateRange(scope.row)), 1)
      ]),
      change: _withCtx((scope) => [
        _createElementVNode("div", {
          style: _normalizeStyle({ color: scope.row.change > 0 ? '#E73323' : '#3B7D22' })
        }, _toDisplayString(scope.row.change ? scope.row.change.toFixed(2) : ''), 5)
      ]),
      change0: _withCtx((scope) => [
        _createElementVNode("div", {
          style: _normalizeStyle({ color: scope.row.change0 > 0 ? '#E73323' : '#3B7D22' })
        }, _toDisplayString(scope.row.change0 ? scope.row.change0.toFixed(2) : ''), 5)
      ]),
      zf: _withCtx((scope) => [
        _createElementVNode("div", {
          style: _normalizeStyle({ color: scope.row.zf > 0 ? '#E73323' : '#3B7D22' })
        }, _toDisplayString(scope.row.zf ? (scope.row.zf * 100).toFixed(2) + '%' : ''), 5)
      ]),
      zf0: _withCtx((scope) => [
        _createElementVNode("div", {
          style: _normalizeStyle({ color: scope.row.zf0 > 0 ? '#E73323' : '#3B7D22' })
        }, _toDisplayString(scope.row.zf0 ? (scope.row.zf0 * 100).toFixed(2) + '%' : ''), 5)
      ]),
      _: 1
    }, 8, ["defaultInfo", "contentTableConfig", "dataList", "dataCount", "onSortChange?"])
  ], 64))
}
}

})